import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BranchSelectResponse, DepartmentForSelectResponse, PositionForSelectResponse, RoleForSelectResponse, SelectPrResponse } from '../models/select.model';
import { BaseResponseModel } from '../models/baseModel';

@Injectable({
    providedIn: 'root'
})
export class SelectApi {
    http = inject(HttpClient);
    httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    baseUrl = `${environment.apiUrl}`;

    GetDepartmentsForSelect() {
        return this.http.get<DepartmentForSelectResponse>(`${this.baseUrl}/departments/select`, this.httpOptions);
    }

    GetPositionsForSelect(departmentId: string) {
        return this.http.get<PositionForSelectResponse>(`${this.baseUrl}/positions/select/${departmentId}`, this.httpOptions);
    }

    GetRolesForSelect() {
        return this.http.get<RoleForSelectResponse>(`${this.baseUrl}/roles/select`, this.httpOptions);
    }

    GetAccountingNumberDropdown() {
        return this.http.get<SelectPrResponse>(`${this.baseUrl}/accounting-number/select`, this.httpOptions);
    }

    GetVendorListDropdown() {
        return this.http.get<SelectPrResponse>(`${this.baseUrl}/vendor/select`, this.httpOptions);
    }

    GetRequestTypeDropdown() {
        return this.http.get<SelectPrResponse>(`${this.baseUrl}/request-type/select`, this.httpOptions);
    }

    GetBranchDropdown() {
        return this.http.get<BranchSelectResponse>(`${this.baseUrl}/select/branches/STE`, this.httpOptions);
    }

    GetBranchByUserId(userId: string) {
        {
            return this.http.get<BranchSelectResponse>(`${this.baseUrl}/user/get-select-branch-by-user/${userId}`, this.httpOptions);
        }

    }

}
